import { SxProps, Theme } from "@mui/material";

export function listCertificatesWrapper(theme: Theme): SxProps<Theme> {
    return {
        zIndex: 1, 
        width: "100%", 
        borderRadius: "20px 20px 0 0", 
        my: "24px", 
        height: "calc(100vh - (84px * 1) - 2px - 48px)", 
        maxHeight: "calc(100vh - (84px * 1) - 2px - 48px)"
    };
}

export function heightWrapper(theme: Theme): SxProps<Theme> {
    return {
        // height: "calc(100vh - (84px * 1) - 2px - 48px)", 
        // maxHeight: "calc(100vh - (84px * 1) - 2px - 48px)"
        height: "100",
    }
}

export function titleWrapper(theme: Theme): SxProps<Theme> {
    return {
        width: "100%",
        textAlign: "center",
        backgroundColor: "#ececec"
    };
}

export function tableHeaderCell(theme: Theme): SxProps<Theme> {
    return {
        backgroundColor: "#ececec",
        minWidth: 100
    };
}

export function error(theme: Theme): SxProps<Theme> {
    return {
        color: "red",
        fontSize: "0.75em",
        textAlign: "center",
        marginTop: "1em"
    };
}